var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"oxy-text-input"},[_c('TextInput',{attrs:{"placeholder":_vm.placeholder},model:{value:(_vm.syncedValue),callback:function ($$v) {_vm.syncedValue=$$v},expression:"syncedValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }